export function isSomeTaxonCodeIncludedInList(taxonCodes: string[], lookupTaxonList: string[]) {
  return lookupTaxonList?.some((code) => code && taxonCodes?.includes(code))
}
